import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { AdicionalEDesconto } from 'src/app/admihair/api/dto/adicional-e-desconto';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { AdicionalEDescontoService } from 'src/app/admihair/service/adicional-e-desconto.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-adicionais-e-descontos-inserir',
  templateUrl: './adicionais-e-descontos-inserir.component.html',
  styleUrls: ['./adicionais-e-descontos-inserir.component.scss']
})
export class AdicionaisEDescontosInserirComponent implements OnInit {

  @ViewChild('f') formulario?: NgForm;
  permissaoInserir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  empresaSelecionada?: Empresa;
  profissionais: Profissional[] = [];
  profissionalSelecionado?: Profissional;
  contas: PlanoContaEmpresa[] = [];
  registro: Date = new Date();
  competencia: Date = new Date();
  valorRegistroDigitado: number = 0;
  exibirMensagem: boolean = false;

  constructor(private adicionalEDescontoService: AdicionalEDescontoService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private profissionalService: ProfissionalService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService,) { }



  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_ADICIONAIS_E_DESCONTOS');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoInserir) {
      this.carregarProfissionais();
      this.carregarContas();
    }
  }

  salvar() {
    this.progressoRequisicao = true;
    const registroAdicional: AdicionalEDesconto = this.formulario?.value;
    registroAdicional.profissionalId = this.profissionalSelecionado?.id;
    registroAdicional.contratoId = this.profissionalSelecionado?.contrato?.id;
    registroAdicional.empresaId = this.empresaSelecionada?.id;
    registroAdicional.operador = this.utilStorageService.getUser().usuario.id

    this.adicionalEDescontoService.salvar(registroAdicional).subscribe({
      next: (data: AdicionalEDesconto) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.limparFormulario();
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagem = true;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })

  }

  carregarContas() {
    const grupoId = 3;
    const utilizacoes = ['FOLHA DE PAGAMENTO', 'FOLHA/DESPESA'];
    this.planoContaEmpresaService.listarPorEmpresaGrupoEUtilizacao(
      this.empresaSelecionada?.id,
      grupoId,
      utilizacoes).subscribe({
        next: (data: PlanoContaEmpresa[]) => {
          this.contas = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      })
  }


  carregarProfissionais() {
    this.profissionalService.listarAtivosPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Profissional[]) => {
        this.profissionais = data;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }


  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  limparFormulario() {
    this.formulario?.reset();
    this.exibirMensagem = false;
    this.valorRegistroDigitado = 0;
    this.registro = new Date();
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
